import { m } from "#/paraglide/messages";
import { createFileRoute } from "@tanstack/react-router";

// Placeholder student-detail overview tab (portal's `_protected.$school.students.$id.overview`).
export const Route = createFileRoute(
  "/$locale/{-$schoolyear}/_authenticated/$school/students/$id/overview",
)({
  component: StudentOverview,
});

function StudentOverview() {
  return (
    <div className="p-6">
      <p className="text-muted-fg">{m["student.overview_placeholder"]()}</p>
    </div>
  );
}
